import { ReactElement, useMemo, useCallback, useRef } from 'react';

import { FormHandles } from '@unform/core';
import { useHistory } from 'react-router-dom';

import { DatePicker } from '~/components';
import ContainerDate from '~/components/ContainerDate';
import { handleGetDataInfo } from '~/pages/Billing/Main';

import * as S from './styles';

function IBOSS(): ReactElement {
  const formRef = useRef<FormHandles>(null);
  const router = useHistory();

  const handleGoIBOSSOption = useCallback(
    (ILABCategory: string) => {
      const data: any = formRef.current?.getData();

      router.push(`/iboss/${ILABCategory}?${handleGetDataInfo(data)}`);
    },
    [router],
  );

  const ILABMenuMemo = useMemo(() => {
    const IBOSSMenuOptions = [
      { label: 'CRM - TREINADORES', value: 'trainer-charts' },
      { label: 'CRM - ALUNOS', value: 'student-charts' },
      { label: 'CRM - FATURAMENTOS', value: 'finance-charts' },
    ];

    return IBOSSMenuOptions.map(({ label, value }) => (
      <S.IBOSSMenuItem key={label}>
        <S.IBOSSMenuLink onClick={() => handleGoIBOSSOption(value)}>
          {label} <span>{'>'}</span>
        </S.IBOSSMenuLink>
      </S.IBOSSMenuItem>
    ));
  }, [handleGoIBOSSOption]);

  const handleSelectIBossOption = () => {
    return (
      <S.IBossOptionMenu
        id="edit-package"
        ref={formRef}
        onSubmit={() => {
          console.log('hey');
        }}
      >
        <ContainerDate label="Data início">
          <DatePicker name="initial_date" fieldLabel="" />
        </ContainerDate>

        <ContainerDate label="Data final">
          <DatePicker name="final_date" fieldLabel="" />
        </ContainerDate>

        {/* <ContainerDate label="Selecionar período">
          <Select
            name="period"
            options={BillingTimeOptions}
            containerStyle={{
              borderRadius: 0,
              backgroundColor: 'transparent',
              border: 'none',
              fontWeight: 'bold',
            }}
            initialValue={BillingTimeOptions[0]}
          />
        </ContainerDate> */}
      </S.IBossOptionMenu>
    );
  };

  return (
    <S.Container>
      {handleSelectIBossOption()}
      <S.IBOSSMenu>{ILABMenuMemo}</S.IBOSSMenu>
    </S.Container>
  );
}

export default IBOSS;
